import localhost from "../../../apis/localhost";
import {
  setSharepointAuthUrl,
  setSharepointError,
  setSharepointLoading,
} from "../sharepointSlice";

export const authenticateSharepointForAddIn = () => async (dispatch) => {
  dispatch(setSharepointLoading(true));
  try {
    const response = await localhost.get("/sharepoint/addin/authorization");

    if (response.status !== 200) {
      throw new Error(`SharePoint add-in auth failed: ${response.statusText}`);
    }

    dispatch(setSharepointAuthUrl(response.data.url));
  } catch (error) {
    dispatch(setSharepointError(error));
  } finally {
    dispatch(setSharepointLoading(false));
  }
};
